import http, { expandURI } from '@/utils/ajax'
import { USER_PROFILE_LOADING, USER_PROFILE_SUCCESS, USER_PROFILE_FAIL, USER_TOKEN_DETAILS_UPDATE, USER_NOTIFICATION_LOADING, USER_NOTIFICATION_SUCCESS, USER_NOTIFICATION_FAIL, USER_NOTIFICATION_LOADMORE_LOADING, USER_NOTIFICATION_LOADMORE_SUCCESS, USER_NOTIFICATION_LOADMORE_FAIL } from '@/store/types'
import { extractMenu, extractMessages } from '@/utils/extract'

export const actions = {
  async initProfile({ commit, rootState }) {
    commit(USER_PROFILE_LOADING)
    const apiUrl = rootState.app.menu.profile
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      let commitResult = result.data
      Object.assign(commitResult, {
        menu: menu
      })
      // Update user module state
      commit(USER_PROFILE_SUCCESS, commitResult)

      // As token module is seperated and consist of certain user fields, we will update it as well
      commit(USER_TOKEN_DETAILS_UPDATE, commitResult)
    } catch (error) {
      commit(USER_PROFILE_FAIL, extractMessages(error))
    }
  },
  async initNotification({ commit, rootState }) {
    commit(USER_NOTIFICATION_LOADING)
    const apiUrl = rootState.app.menu.notification
    const expand = {}
    if (apiUrl) {
      try {
        const result = await http.get(expandURI(apiUrl, expand))
        const menu = extractMenu(result.data._links)
        let commitResult = result.data
        Object.assign(commitResult, {
          menu: menu
        })
        commit(USER_NOTIFICATION_SUCCESS, commitResult)
      } catch (error) {
        console.log(error)
        commit(USER_NOTIFICATION_FAIL)
      }
    } else {
      commit(USER_NOTIFICATION_FAIL)
    }
  },
  async loadMoreNotification({ commit, state }) {
    if (!state.notification.loadingNewNotification && state.notification.hasNext) {
      commit(USER_NOTIFICATION_LOADMORE_LOADING)

      const apiUrl = state.notification.menu.next
      if (apiUrl) {
        try {
          const result = await http.get(apiUrl)
          const menu = extractMenu(result.data._links)
          let commitResult = result.data
          Object.assign(commitResult, {
            menu: menu
          })
          commit(USER_NOTIFICATION_LOADMORE_SUCCESS, commitResult)
        } catch (error) {
          console.log(error)
          commit(USER_NOTIFICATION_LOADMORE_FAIL)
        }
      } else {
        commit(USER_NOTIFICATION_LOADMORE_FAIL)
      }
    }
  }
}
